"use strict";

require("./..\\..\\..\\bower_components\\jquery.serializeJSON\\jquery.serializejson.js");

var ymaps = window.ymaps;


module.exports = function () {
	if (!ymaps) {
		return console.log('yandex map api not found');
	}
	ymaps.ready(init);
};

function init() {
	ymaps.option.presetStorage.add('customIslands#in-progress', {
		iconLayout: 'default#image',
		iconImageClipRect: [[40,0], [71, 50]],
		iconImageHref: '/bitrix/templates/common_v1/images/placemarks.png',
		iconImageSize: [31, 50],
		iconImageOffset: [-16, -44]
	});

	ymaps.option.presetStorage.add('customIslands#well-done', {
		iconLayout: 'default#image',
		iconImageClipRect: [[0,0], [31, 50]],
		iconImageHref: '/bitrix/templates/common_v1/images/placemarks.png',
		iconImageSize: [31, 50],
		iconImageOffset: [-16, -44]
	});

	$('[int-map]').each(function () {

		var $wrap = $(this),
			$form = $wrap.find('form'),
			ajaxUrl = $form.attr('action'),
			$mapWrap = $wrap.find('[map]'),
			customOptions = $wrap.data('map-options'),
			map = new Map($mapWrap[0], customOptions);

		$form.on('change', function () {
			$.getJSON(ajaxUrl, $form.serializeJSON())
				.then(function (response) {
					map.rebuildPoints(response);
				});
		});

		$form.trigger('change');
	});
}

function Map(mapContainer, customOptions) {
	var options = $.extend({
			center: [59.933307, 30.308376], // SPB - 59.933307, 30.308376
			zoom: 11
		}, customOptions);

	this.map = new ymaps.Map(mapContainer, options);
	this.map.behaviors.disable('scrollZoom');
}

Map.prototype.rebuildPoints = function (objects) {
	var geoObjects =  new ymaps.GeoObjectCollection();

	$.each(objects, function (index, object) {
		geoObjects.add(new ymaps.Placemark(
			[object.x, object.y],
			{
				balloonContentHeader : object.name,
				balloonContentBody : object.description + ' <strong><a href="'+ object.url +'">Подробнее</a></strong>'
			},
			{
				preset: 'customIslands#' + object.section
			}
		));
	});
	this.map.geoObjects.removeAll();
	this.map.geoObjects.add(geoObjects);
};


